// noinspection SqlDialectInspection

// Display-name maps for enums whose values live in popdock-shared/constants/*.jsx
// (e.g. FieldTypes here pairs with FieldType in constants/field.jsx), plus small
// option/format lists.

export const DataLakeFileFormats = {
    CSV: "CSV",
    JSON: "JSON",
    PARQUET: "Parquet",
    XML: "XML",
    CSV_GZIP: "CSV (gzipped)",
    JSON_GZIP: "JSON (gzipped)",
    PARQUET_GZIP: "Parquet (gzipped)",
    XML_GZIP: "XML (gzipped)",
};

export const FieldTypes = {
    Currency: "Currency",
    Date: "Date",
    Email: "Email",
    Image: "Image",
    Integer: "Number",
    Percentage: "Percentage",
    Phone: "Phone",
    Quantity: "Quantity",
    Skype: "Skype",
    String: "String",
    Text: "Text",
    Time: "Time",
    Twitter: "Twitter",
    Url: "Website",
    YesNo: "Yes/no",
    Enum: "Drop-down list",
    Color: "Color",
    Address: "Address",
    Guid: "GUID",
    Icon: "Icon",
    TimeSpan: "Time span",
    Profile: "Profile",
    Dimension: "Dimension",
    File: "File",
    None: "None",
    Timespan: "TimeSpan",
    StringList: "String list", 
    IntegerList: "Integer list"

};

export const ChartTypes = {
    Column: "Column",
    Bar: "Bar",
    Pie: "Pie",
    Doughnut: "Donut",
    Area: "Area",
    Line: "Line",
    Funnel: "Funnel",
    Number: "Number",
    Bubble: "Bubble",
    TreeMap: "Tree map",
    BumpChart: "Bump",
    WordCloud: "Word cloud",
    Sankey: "Sankey",
    Pyramid: "Pyramid",
    Lollipop: "Lollipop",
    StepLine: "Step line",
    Tornado: "Tornado",
    Waterfall: "Waterfall",
    Radar: "Radar",
    RadialGauge: "Radial gauge",
    PackedBubble: "Packed bubble"
};

export const Months = {
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December"
};

export const DaysOfWeek = {
    Sunday: "Sunday",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday"
};

export const Operators = {
    Equals: "Equals",
    NotEquals: "Does not equal",
    OneOfList: "One of list",
    NotOneOfList: "Not one of list",
    Between: "Between",
    NotBetween: "Not between",
    Greater: "Greater than",
    Less: "Less than",
    GreaterEqual: "Greater than or equal to",
    LessEqual: "Less than or equal to",
    Contains: "Contains",
    StartsWith: "Starts with",
    EndsWith: "Ends with",
    NotContains: "Does not contain",
    NotStartsWith: "Does not start with",
    NotEndsWith: "Does not end with",
    Null: "Is null",
    NotNull: "Is not null"
};

export const DateValues = {
    Today: "Today",
    Yesterday: "Yesterday",
    Tomorrow: "Tomorrow",
    StartOfWeek: "Start of week",
    EndOfWeek: "End of week",
    StartOfMonth: "Start of month",
    EndOfMonth: "End of month",
    StartOfQuarter: "Start of quarter",
    EndOfQuarter: "End of quarter",
    StartOfYear: "Start of year",
    EndOfYear: "End of year",
    StartOfThisFiscalPeriod: "Start of fiscal period",
    EndOfThisFiscalPeriod: "End of fiscal period",
    StartOfLastWeek: "Start of last week",
    EndOfLastWeek: "End of last week",
    StartOfLastMonth: "Start of last month",
    EndOfLastMonth: "End of last month",
    StartOfLastQuarter: "Start of last quarter",
    EndOfLastQuarter: "End of last quarter",
    StartOfLastYear: "Start of last year",
    EndOfLastYear: "End of last year",
    StartOfLastFiscalPeriod: "Start of last fiscal period",
    EndOfLastFiscalPeriod: "End of last fiscal period",
    StartOfNextWeek: "Start of next week",
    EndOfNextWeek: "End of next week",
    StartOfNextMonth: "Start of next month",
    EndOfNextMonth: "End of next month",
    StartOfNextQuarter: "Start of next quarter",
    EndOfNextQuarter: "End of next quarter",
    StartOfNextYear: "Start of next year",
    EndOfNextYear: "End of next year",
    StartOfNextFiscalPeriod: "Start of next fiscal period",
    EndOfNextFiscalPeriod: "End of next fiscal period",
    ThisWeek: "This week",
    LastWeek: "Last week",
    NextWeek: "Next week",
    ThisMonth: "This month",
    LastMonth: "Last month",
    NextMonth: "Next month",
    ThisQuarter: "This quarter",
    LastQuarter: "Last quarter",
    NextQuarter: "Next quarter",
    ThisYear: "This year",
    LastYear: "Last year",
    NextYear: "Next year",
    ThisFiscalPeriod: "This fiscal period",
    LastFiscalPeriod: "Last fiscal period",
    NextFiscalPeriod: "Next fiscal period",
    StartOfThisFiscalYear: "Start of fiscal year",
    EndOfThisFiscalYear: "End of fiscal year",
    StartOfLastFiscalYear: "Start of last fiscal year",
    EndOfLastFiscalYear: "End of last fiscal year",
    StartOfNextFiscalYear: "Start of next fiscal year",
    EndOfNextFiscalYear: "End of next fiscal year",
    ThisFiscalYear: "This fiscal year",
    LastFiscalYear: "Last fiscal year",
    NextFiscalYear: "Next fiscal year"
};

export const DateFormats = {
    Date: "Date",
    Day: "Day",
    DayOfWeek: "Day of week",
    Month: "Month",
    Year: "Year",
    MonthYear: "Year-Month",
    FiscalPeriod: "Fiscal period",
    FiscalYear: "Fiscal year",
    FiscalPeriodYear: "Fiscal period/year"
};

export const SummaryMethods = {
    Average: "Average",
    Sum: "Sum",
    Max: "Maximum",
    Min: "Minimum",
    Earliest: "Earliest", 
    Latest: "Latest", 
    Count: "Count",
    GroupBy: "Group by",
    None: "None",
    Rank: "Rank",
    RankNoTies: "Rank (no ties)",
    Median: "Median",
    Mode: "Mode",
    StandardDeviation: "Standard deviation",
    Variance: "Variance",
    DistinctCount: "Distinct count",
    DistinctValue: "Distinct values",
    First: "First",
    Last: "Last"
};

export const TextFormats = {
    Plain: "Plain text",
    Html: "HTML",
    Markdown: "Markdown"
};

export const Formats = {
    Locale: "en-US",
    Currency: "USD",
    Date: "M/D/YYYY",
    Day: "D",
    Month: "MMMM",
    Year: "YYYY",
    MonthYear: "MMMM YYYY",
    DayOfWeek: "dddd",
    Time: "hh:mm",
    GridDate: "{0: M/d/yyyy}",
    GridDay: "{0: d}",
    GridMonth: "{0: MMMM}",
    GridYear: "{0: yyyy}",
    GridMonthYear: "{0: MMMM yyyy}",
    GridDayOfWeek: "{0: dddd}",
    GridTime: "{0: hh:mm tt}",
    TextDate: "YYYY-MM-DD"
};

export const CustomEntityTypes = {
    Summary: "Summary",
    Joined: "Joined",
    Merged: "Merged",
    Comparison: "Comparison",
    Restriction: "Restriction",
    Matrix: "Matrix"
};

export const ApiRequestMethods = {
    Get: "GET",
    Post: "POST",
    Patch: "PATCH",
    Delete: "DELETE",
    Put: "PUT"
};

export const DataLakeChunkGranularity = {
    Date: {
        Day: "Day",
        Month: "Month",
        Year: "Year"
    },
    String: {
        None: "None",
        OneChar: "First character",
        TwoChars: "First 2 characters",
        ThreeChars: "First 3 characters",
        FourChars: "First 4 characters",
        FiveChars: "First 5 characters"
    }
};

export const JobEmailAttachmentFormats = {
    Excel: "Excel",
    Csv: "CSV",
    Markdown: "Markdown"
};

export const WidgetParameterTypes = {
    None: "None",
    Field: "Add filter on field",
    Variable: "Set variable"
};

export const ActionDisplayTypes = {
    Background: "Run as a background process",
    Form: "Display a form",
    Confirmation: "Display a confirmation prompt",
    DrillDownForm: "Display a drill down form"
};

export const FirewallTypes = {
    WebApp: "Web application",
    Api: "API",
    Excel: "Excel addin",
    Widgets: "Widgets"
};

export const TimespanUnits = {
    Second: "Seconds",
    Minute: "Minutes",
    Hour: "Hours",
    Day: "Days",
    MinuteSecond: "Minutes:Seconds",
    HourMinute: "Hours:Minutes",
    HourMinuteSecond: "Hours:Minutes:Seconds"
};

export const ReportingTreeTypes = {
    CalendarDate: "Date tree",
    FiscalPeriod: "Fiscal period tree",
    MultiField: "Multi-field tree"
};

export const ReportingTreeDateLevels = {
    Year: "Year",
    Quarter: "Quarter",
    Month: "Month",
    Day: "Day",
    Week: "Week",
    DayOfWeek: "Day of week"
};

export const ActionTypes = {
    OpenUrl: "Open a website",
    OpenForm: "Open a form",
    RequestMethod: "Request API method",
    ConnectorAction: "Run a connector action",
    SmartConnect: "Run a SmartConnect process",
    SmartConnectError: "Process SmartConnect errors",
    SendApiRequest: "Send an API request",
    Flow: "Trigger a Microsoft Power Automate flow",
    RunWorkflow: "Run a workflow"
};

export const JoinMethods = {
    Equals: "Inner",
    Left: "Left outer",
    Right: "Right outer",
    Full: "Full outer",
    Cross: "Cross join"
};

export const DateSummaryMethods = {
    None: "None",
    Day: "Day",
    Month: "Month",
    Year: "Year"
};

export const GenerateFiscalPeriodMethods = {
    Month: "Add a period for each month",
    FourWeek: "Add a period every 4 weeks",
    Week: "Add a period for each week",
    Quarter: "Add a period for each quarter"
};

export const DimensionValueTypes = {
    Code: "Dimension code",
    Description: "Description"
};
